export const editableHighlightModes = ['hide', 'hover', 'show']
export const normaliseEditableHighlightMode = value => {
  if (value === true || value === 'true' || value === 'show') return 'show'
  if (value === false || value === 'false' || value === 'hover' || value === 'show-on-mouseover') return 'hover'
  return editableHighlightModes.includes(value) ? value : 'show'
}
export const nextEditableHighlightMode = value => {
  const current = normaliseEditableHighlightMode(value)
  return editableHighlightModes[(editableHighlightModes.indexOf(current) + 1) % editableHighlightModes.length]
}
